var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk50(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 30",
    style: {
      enableBackground: "new 0 0 58.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,16L7.8,16c0.1,0.6,0.3,1,0.6,1.3c0.3,0.3,0.7,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.6 c0-0.6-0.2-1.1-0.5-1.5c-0.4-0.4-0.8-0.5-1.4-0.5c-0.4,0-0.7,0.1-1,0.2C8.2,13.8,8,14,7.8,14.3l-1-0.1l0.9-4.6h4.5v1.1H8.6L8.1,13 c0.5-0.4,1.1-0.6,1.7-0.6c0.8,0,1.5,0.3,2,0.8c0.5,0.5,0.8,1.2,0.8,2.1c0,0.8-0.2,1.5-0.7,2.1c-0.6,0.7-1.4,1.1-2.4,1.1 c-0.8,0-1.5-0.2-2-0.7C7,17.4,6.7,16.8,6.6,16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: -6.8,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 0.5167 15.863)",
    width: 0.9,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 21,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -8.8678 9.7347)",
    width: 28.6,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 10.9,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M0.9,29.1h28.2V0.9H0.9V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,25.9H4V3.8h22.5V25.9z M4.8,25h20.9V4.6H4.8V25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9,
    y: -6.8,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 15.7227 41.2595)",
    width: 0.9,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 21,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -5.0021 24.1502)",
    width: 28.6,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30h-30V0h30V30z M29.7,29.1h28.2V0.9H29.7V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,25.9H32.8V3.8h22.5V25.9z M33.6,25h20.9V4.6H33.6V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk50);
export default __webpack_public_path__ + "static/media/ak_5_0.16d416bd9410562c64bf843f3a57ad19.svg";
export { ForwardRef as ReactComponent };